import { render } from "./EventAddTiktok.vue?vue&type=template&id=180c484e"
import script from "./EventAddTiktok.vue?vue&type=script&lang=js"
export * from "./EventAddTiktok.vue?vue&type=script&lang=js"

import "./EventAddTiktok.vue?vue&type=style&index=0&id=180c484e&lang=scss&scope=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__